var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "#828282",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.04C7.62 7.04 7.28 7.19 7.02 7.425L3.455 5.35C3.48 5.235 3.5 5.12 3.5 5C3.5 4.88 3.48 4.765 3.455 4.65L6.98 2.595C7.25 2.845 7.605 3 8 3C8.83 3 9.5 2.33 9.5 1.5C9.5 0.67 8.83 0 8 0C7.17 0 6.5 0.67 6.5 1.5C6.5 1.62 6.52 1.735 6.545 1.85L3.02 3.905C2.75 3.655 2.395 3.5 2 3.5C1.17 3.5 0.5 4.17 0.5 5C0.5 5.83 1.17 6.5 2 6.5C2.395 6.5 2.75 6.345 3.02 6.095L6.58 8.175C6.555 8.28 6.54 8.39 6.54 8.5C6.54 9.305 7.195 9.96 8 9.96C8.805 9.96 9.46 9.305 9.46 8.5C9.46 7.695 8.805 7.04 8 7.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.38525d68abf80e5391134e9d33a57ed4.svg";
export { ForwardRef as ReactComponent };